import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, Brain } from 'lucide-react';
import { useAIGenerationEnabled } from '../../hooks/useAIGenerationEnabled';

export function AdminAIWarningBanner() {
  const { isEnabled, loading } = useAIGenerationEnabled();
  const navigate = useNavigate();

  if (loading || isEnabled) {
    return null;
  }

  return (
    <div className="bg-red-600 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <AlertTriangle className="w-6 h-6 flex-shrink-0" />
            <div>
              <p className="font-semibold text-base">
                AI Generatie is uitgeschakeld
              </p>
              <p className="text-sm text-red-100 mt-0.5">
                Users kunnen geen nieuwe content maken met AI. Schakel AI generatie in om de dienst te hervatten.
              </p>
            </div>
          </div>
          <button
            onClick={() => navigate('/admin/ai-settings')}
            className="flex items-center gap-2 px-4 py-2 bg-white text-red-600 rounded-lg hover:bg-red-50 transition-colors font-medium text-sm whitespace-nowrap flex-shrink-0"
          >
            <Brain className="w-4 h-4" />
            Naar AI Settings
          </button>
        </div>
      </div>
    </div>
  );
}
